import type { ModuleDefinition } from '../types';

export const notificationsModule: ModuleDefinition = {
  key: 'notifications',
  milestone: 'M1',
  network: {
    // REQ-NTF-001 / M1 §6.3: leitura (lista, versões, preview) exige só `notification.template.read` — os
    // aprovadores (QA/DPO) precisam ler o que assinam sem poder editar.
    path: 'notification-templates',
    permission: 'notification.template.read',
    labelKey: 'notifications',
  },
  tenant: null,
  load: () => import('./NotificationsModule'),
};
